module.exports = __webpack_public_path__ + "static/media/table-tennis.d9f269fd.png";